export default function relatorios(podeAcessar) {
  return [
    {
      name: 'Inicio',
      icon: 'fa fa-th-large fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: true,
      link: '/app/rel/inicio',
    },
    {
      name: '01. Processos',
      icon: 'fa fa-file-excel-o fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      ativo: podeAcessar('rel_01'),
      children: [
        {
          name: '01.01 - Consulta Geral',
          type: 'item',
          ativo: true,
          link: '/app/rel/processos/consulta-geral',
        },
        {
          name: '01.02 - Lista de Processos',
          type: 'item',
          ativo: true,
          link: '/app/rel/processos/listagem',
        },
        {
          name: '01.04 - Status de Processo x Credor',
          type: 'item',
          ativo: true,
          link: '/app/rel/processos/status-credor',
        },
        {
          name: '01.05 - Status de Processo x Negociador',
          type: 'item',
          ativo: true,
          link: '/app/rel/processos/status-negociador',
        },
        {
          name: '01.06 - Qtde de Processos x Região',
          type: 'item',
          ativo: true,
          link: '/app/rel/processos/por-regiao',
        },
        {
          name: '01.07 - Processos s/ Títulos',
          type: 'item',
          ativo: true,
          link: '/app/rel/processos/sem-titulos',
        },
      ],
    },
    {
      name: '02. Históricos / Ocorrências',
      icon: 'fa fa-file-excel-o fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      ativo: podeAcessar('rel_02'),
      children: [
        {
          name: '02.01 - Ocorrências',
          type: 'item',
          ativo: true,
          link: '/app/rel/ocorrencias/listagem',
        },
        {
          name: '02.02 - Ocorrências / PDF',
          type: 'item',
          ativo: true,
          link: '/app/rel/ocorrencias/pdf',
        },
      ],
    },
    {
      name: '03. Títulos',
      icon: 'fa fa-file-excel-o fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      ativo: podeAcessar('rel_03'),
      children: [
        {
          name: '03.01 - Lista de Títulos',
          type: 'item',
          ativo: true,
          link: '/app/rel/titulos/cadastrados',
        },
        {
          name: '03.02 - Lista de Importações',
          type: 'item',
          ativo: true,
          link: '/app/rel/titulos/importacoes',
        },
        {
          name: '03.03 - Títulos Duplicados',
          type: 'item',
          ativo: true,
          link: '/app/rel/titulos/duplicados',
        },
        {
          name: '03.04 - Borderôs de Entrada / PDF',
          type: 'item',
          ativo: true,
          link: '/app/rel/titulos/borderos-entrada',
        },
      ],
    },
    {
      name: '04. Credores',
      icon: 'fa fa-file-excel-o fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      ativo: podeAcessar('rel_04'),
      children: [
        {
          name: '04.01 - Lista de Credores',
          type: 'item',
          ativo: true,
          link: '/app/rel/credores/listagem',
        },
        {
          name: '04.02 - Gerencial Credor',
          type: 'item',
          ativo: true, // ajuste o controle de acesso se necessário
          link: '/app/rel/credores/gerencial',
        },
      ],
    },
    {
      name: '05. Devedores',
      icon: 'fa fa-file-excel-o fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      ativo: podeAcessar('rel_05'),
      children: [
        {
          name: '05.01 - Lista de Devedores',
          type: 'item',
          ativo: true,
          link: '/app/rel/devedores/listagem',
        },
      ],
    },
    {
      name: '06. Negociadores',
      icon: 'fa fa-file-excel-o fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      ativo: podeAcessar('rel_06'),
      children: [
        {
          name: '06.01 - Produtividade',
          type: 'item',
          ativo: true,
          link: '/app/rel/negociador/produtividade',
        },
        {
          name: '06.02 - Pausas',
          type: 'item',
          ativo: true,
          link: '/app/rel/negociador/pausas',
        },
        {
          name: '06.03 - Comissões',
          type: 'item',
          ativo: true,
          link: '/app/rel/negociador/comissoes',
        },
      ],
    },
    {
      name: '07. Consultor / Comercial',
      icon: 'fa fa-file-excel-o fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      ativo: podeAcessar('rel_07'),
      children: [
        {
          name: '07.01 - Títulos Captados - Mensal',
          type: 'item',
          ativo: true,
          link: '/app/rel/consultor-comercial/titulos-captados',
        },
        {
          name: '07.xx - Movimentação Anual de Clientes',
          type: 'item',
          ativo: false,
          link: '/app/rel/mov-anual-clientes',
        },
        {
          name: '07.02 - Títulos Captados - Faixa Vencto',
          type: 'item',
          ativo: true,
          link: '/app/rel/consultor-comercial/faixa-vencimento',
        },
        {
          name: '07.03 - Credores Que Não Enviam Borderôs X Dias',
          type: 'item',
          ativo: true,
          link: '/app/rel/consultor-comercial/credores-sem-bordero',
        },
        {
          name: '07.04 - Comissões',
          type: 'item',
          ativo: true,
          link: '/app/rel/consultor-comercial/comissoes',
        },
      ],
    },
    {
      name: '08. Financeiro',
      icon: 'fa fa-file-excel-o fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      ativo: podeAcessar('rel_08'),
      children: [
        {
          name: '08.01 - Contas à Receber / Recebidas',
          type: 'item',
          ativo: true,
          link: '/app/rel/contas-a-receber',
        },
        {
          name: '08.02 - Contas à Pagar / Pagas',
          type: 'item',
          ativo: true,
          link: '/app/rel/contas-a-pagar',
        },
        {
          name: '08.03 - Movimetações de Contas',
          type: 'item',
          ativo: true,
          link: '/app/rel/mov-contas',
        },
      ],
    },
    {
      name: '09. Gerencial',
      icon: 'fa fa-file-excel-o fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      ativo: podeAcessar('rel_09'),
      children: [
        {
          name: '09.02 - Remuneração por Credor',
          type: 'item',
          ativo: true,
          link: '/app/rel/lista-remuneracao-credor',
        },
        {
          name: '09.03 - Remuneração por Negociador',
          type: 'item',
          ativo: true,
          link: '/app/rel/lista-remuneracao-negociador',
        },
      ],
    },
    {
      name: '10. Remessa / Retorno',
      icon: 'fa fa-file-text-o fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      ativo: podeAcessar('rel_remessa'),
      children: [
        {
          name: 'Entrada Confirmada',
          type: 'item',
          ativo: true,
          link: '/app/rel/entrada-confirmada',
        },
        {
          name: 'Liquidações',
          type: 'item',
          ativo: true,
          link: '/app/rel/liquidacoes',
        },
        {
          name: 'Devoluções',
          type: 'item',
          ativo: true,
          link: '/app/rel/devolucoes',
        },
        {
          name: 'Liquidações/Devoluções',
          type: 'item',
          ativo: false,
        },
        {
          name: 'Ocorrências',
          type: 'item',
          ativo: true,
          link: '/app/rel/ocorrencias',
        },
      ],
    },
    {
      name: 'Relatórios Personalizados',
      icon: 'fa fa-file-text-o fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('rel_personalizados'),
      link: '/app/rel/personalizados',
    },
    {
      name: 'Criação de Documentos',
      icon: 'fa fa-bolt fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('rel_gerador'),
      link: '/app/rel/criacao-documentos',
    },
    {
      name: 'Logs de Relatórios Gerados',
      icon: 'fa fa-history fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('modulo_relatorios'),
      link: '/app/rel/logs-relatorios-gerados',
    },
  ];
}
